import { Locales } from './locales';

import en from './en.json'
import pt from './pt.json'
import ru from './ru.json'
import es from './es.json'
import it from './it.json'
// @ts-ignore
import pt_BR from './pt-br.json'


export const messages = {
  [Locales.EN]: en, // English
  [Locales.RU]: ru, // Русский
  [Locales.PT]: pt, // Português Europeu
  [Locales.BT]: pt_BR, // Português Brasileiro
  [Locales.ES]: es, // Español
  [Locales.IT]: it, // Italiano
};

export const defaultLocale = Locales.EN;
